import React from "react";
import { ShowTotal, AppContainer } from "../../../Components/Global/Reusable";
import StyledTable from "../../../Components/Table";
import BodyData from "./BodyData";
import Labels from "./Labels";
import Details from "./Details";
import { UpdateRow } from "../../../features/GuideReportSlice";
import BlockModal from "../../../Components/BlockModal";
import DialogModal from "../../../Components/DialogModal";
import ImageModal from "../../../Components/DialogModal/ImageModal";
import { Toast } from "../../../Components/Toast";
import { TABLES } from "../../../enums/tables";
import { useConnectsalesReport } from "./hooks/useConnectsalesReport";

export default function Index() {
  const {
    data,
    setData,
    Id,
    details,
    preview,
    setPreview,
    isToastOpen,
    toastMessage,
    orderFilter,
    setOrderFilter,
    secondaryFilter,
    filteredDataLength,
    setFilteredDataLength,
    dateFilter,
    setDateFilter,
    modalNameFilter,
    setModalNameFilter,
    modalItineraryFilter,
    setModalItineraryFilter,
    modalTypeFilter,
    setModalTypeFilter,
    toggleToast,
    onToastOpen,
    OpenDetails,
    CloseDetails,
    OpenModal,
  } = useConnectsalesReport();

  return (
    <>
      <Toast
        variation={toastMessage.variation}
        title={toastMessage.title}
        open={isToastOpen}
        onOpenChange={toggleToast}
      />
      <AppContainer maxWidth="xl">
        <StyledTable
          TableTitle="ConnectSales"
          Component={<ShowTotal total={filteredDataLength} />}
          Labels={
            <Labels
              modalNameFilter={modalNameFilter}
              modalItineraryFilter={modalItineraryFilter}
              modalTypeFilter={modalTypeFilter}
              setModalNameFilter={setModalNameFilter}
              setModalItineraryFilter={setModalItineraryFilter}
              setModalTypeFilter={setModalTypeFilter}
              orderFilter={orderFilter}
              setOrderFilter={setOrderFilter}
              dateFilter={dateFilter}
              setDateFilter={setDateFilter}
            />
          }
          TableData={
            <BodyData
              modalNameFilter={modalNameFilter}
              modalItineraryFilter={modalItineraryFilter}
              modalTypeFilter={modalTypeFilter}
              setModalNameFilter={setModalNameFilter}
              setModalItineraryFilter={setModalItineraryFilter}
              setModalTypeFilter={setModalTypeFilter}
              secondaryFilter={secondaryFilter}
              orderFilter={orderFilter}
              OpenDetails={OpenDetails}
              OpenModal={OpenModal}
              dateFilter={dateFilter}
              setFilteredDataLength={setFilteredDataLength}
            />
          }
        />
        {details && (
          <Details
            CloseDetails={CloseDetails}
            detailsID={Id}
            openPreview={setPreview}
          />
        )}
        {data && (
          <DialogModal>
            <BlockModal
              onToastOpen={onToastOpen}
              data={data}
              setModal={setData}
              UpdateRow={UpdateRow}
              role="ConnectGuide"
              collection={TABLES.CONNECTSALES}
            />
          </DialogModal>
        )}
        {preview && (
          <DialogModal>
            <ImageModal openPreview={setPreview} image={preview} />
          </DialogModal>
        )}
      </AppContainer>
    </>
  );
}
